module.exports = __webpack_public_path__ + "static/media/upload.727ef2f8.png";